'use client';

import type { StatusAntwort } from '@/lib/api/types';
import seitenRegistryRoh from '../../../shared/page-registry.json';

type SeitenRegistryEintrag = {
  page_key: string;
  default_aktiv?: boolean;
};

export type SeitenFeatureFlags = Record<string, boolean>;

// Default pro Seite stammt aus dem Registry-Feld default_aktiv (Standard: true).
// Seiten mit default_aktiv=false (z. B. rechnungspruefung) sind aus, solange sie
// nicht explizit per Konfiguration aktiviert werden.
const STANDARD_SEITEN_FLAGS = Object.fromEntries(
  (seitenRegistryRoh as SeitenRegistryEintrag[]).map((seite) => [
    seite.page_key,
    seite.default_aktiv ?? true,
  ]),
) as SeitenFeatureFlags;

export function resolveSeitenFeatureFlags(
  status: StatusAntwort | null | undefined,
): SeitenFeatureFlags {
  const flags: SeitenFeatureFlags = { ...STANDARD_SEITEN_FLAGS };
  const konfigurierteFlags = status?.config_zusammenfassung?.features?.seiten ?? {};

  for (const [pageKey, aktiv] of Object.entries(konfigurierteFlags)) {
    if (typeof aktiv === 'boolean') {
      flags[pageKey] = aktiv;
    }
  }

  return flags;
}

export function istSeitenFeatureAktiv(
  pageKey: string | null | undefined,
  seitenFeatureFlags: SeitenFeatureFlags | null | undefined,
): boolean {
  if (!pageKey) {
    return false;
  }
  if (!seitenFeatureFlags) {
    return true;
  }
  return seitenFeatureFlags[pageKey] ?? true;
}